module.exports = __webpack_public_path__ + "img/img_phone2_SFA.7e6e2c29.png";